import React from "react";

export default function PrintFooter() {
  return (
    <div
      style={{
        width: "100%",
        padding: "0.5em 1em", // responsive padding
        borderTop: "1px solid #ccc",
        fontSize: "0.9rem",   // relative font size
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        color: "#333",
        backgroundColor: "#f7f7f7",
        boxSizing: "border-box",
      }}
    >
      &copy; {new Date().getFullYear()} ALL INDIA INSTITUTE OF MEDICAL SCIENCES NAGPUR. All rights reserved.
    </div>
  );
}
